import { qsa } from "@fluorescent/dom";
import { section } from "@/glow";
import { wrapIframes, wrapTables } from "@/lib/rte";
import { animatePage, shouldAnimate } from "@/lib/animation";

section("page", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePage = animatePage(this.container);
    }

    // Required to properly style RTE content
    wrapIframes(qsa("iframe", this.container));
    wrapTables(qsa("table", this.container));
  },

  onUnload() {
    this.animatePage?.destroy();
  },
});
